export default __webpack_public_path__ + "static/media/EmbeddedDev_Flexibility.7e49817e.mp4";